'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createSvg = require('./utils/createSvg');

var _createSvg2 = _interopRequireDefault(_createSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createSvg2.default)(_react2.default.createElement(
  'g',
  null,
  _react2.default.createElement('path', { d: 'M7 9v6h4l5 5V4l-5 5H7z' })
), 'VolumeMute');


//////////////////
// WEBPACK FOOTER
// ./~/material-react-icons/VolumeMute.js
// module id = 985
// module chunks = 0